export default "{\n    \"overdue\": \"Overdue\",\n    \"expiresIn\": \"Expires in\"\n}\n"